<template>
    <div class="gift_sent_root">
        <div class="gift_sent_description">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <path style="fill:#ADEBFF;" d="M304.489,413.234c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.19,54.879
                    l6.323,18.966c26.517-26.517,61.11-60.797,61.457-61.14C307.939,422.406,307.965,416.743,304.489,413.234z"/>
                <path style="fill:#51E9D3;" d="M304.489,372.99c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.191,54.88
                    l6.324,18.965c26.517-26.517,61.11-60.797,61.457-61.14C307.939,382.161,307.965,376.499,304.489,372.99z"/>
                <path style="fill:#E0F4B4;" d="M322.135,85.486V99.65l-85.486,119.023L203.112,93.158L236.649,0
                    C283.869,0,322.135,38.277,322.135,85.486z"/>
                <path style="fill:#51E9D3;" d="M189.865,46.784v327.3c0,25.846,15.483,35.069,46.784,66.37V0
                    C210.814,0,189.865,20.95,189.865,46.784z"/>
                <polygon style="fill:#51A978;" points="322.135,99.65 322.135,212.838 236.649,331.861 236.649,185.136 "/>
                <path style="fill:#3AC099;" d="M322.135,212.838v66.113c0,47.209-28.283,64.056-85.486,121.259V298.324L322.135,212.838z"/>
                <path style="fill:#80086E;" d="M236.65,512c-4.939,0-8.943-4.004-8.943-8.943V33.537c0-4.939,4.004-8.943,8.943-8.943
                    c4.939,0,8.943,4.004,8.943,8.943v469.52C245.593,507.996,241.59,512,236.65,512z"/>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>
            <h1>お祝いを送りました！</h1>
            <p>URLを相手にお知らせください</p>
            <h2>{{this.urlToReceive}}</h2>
        </div>

        <div class="send_by_container">
            <at-tabs>
                <at-tab-pane label="QR Code" name="qr-code">
                    <qrcode-vue :value="this.urlToReceive" level="L"></qrcode-vue>
                </at-tab-pane>
                <at-tab-pane label="Twitter" name="twitter">
                    <at-input v-model="receiverTwitterAccount"
                              placeholder="@お相手のTwitterアカウント"
                              append-button
                              class="share_receiver_account"
                              :disabled="inProgress"
                    >
                        <template slot="append">
                            <a :href="urlToShareOnTwitter"
                               class="share_link"
                               target="_blank"
                            >
                                Twitterでお知らせする
                            </a>
                        </template>
                    </at-input>
                </at-tab-pane>
            </at-tabs>
        </div>

        <div class="cancel_gift_container">
            <at-button type="primary"
                       v-on:click="cancelGift"
                       class="cancel_gift"
                       :disabled="inProgress"
            >
                キャンセル
            </at-button>
            <p>※イーサリアムは返却されます</p>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import store from '../store'
  import QrcodeVue from 'qrcode.vue';

  export default {
    name: 'GiftSent',
    components: {
      QrcodeVue
    },
    computed: {
      ...mapGetters([
        'sendingGift',
        'inProgress',
        'sendMailSucceeded',
        'cancelGiftSucceeded'
      ]),
      urlToReceive: function () {
        return `${process.env.END_POINT}#/receive/?giftUuid=${this.sendingGift ? this.sendingGift.uuid : ''}`
      },
      shareText: function () {
        return `${this.receiverTwitterAccount}さん ${this.sendingGift && this.sendingGift.senderName !== '' ? `${this.sendingGift.senderName}から` : ''}お祝イーサーが届いています！メッセージと一緒に受け取ろう`
      },
      urlToShareOnTwitter: function () {
        return `//twitter.com/share?url=${encodeURIComponent(this.urlToReceive)}&text=${encodeURIComponent(this.shareText)}&hashtags=${encodeURIComponent('お祝イーサー')}`
      }
    },
    watch: {
      inProgress: function (newValue, oldValue) {
        const isProgressEnd = oldValue && !newValue
        if (isProgressEnd) {
          this.$Loading.finish()
        }
      },
      sendMailSucceeded: function (newValue, oldValue) {
        const isSendingSucceeded = newValue
        if (isSendingSucceeded) {
          this.$Message.success('メールを送りました!')
        } else {
          this.$Message.error('メール送信に失敗しました')
        }
      },
      cancelGiftSucceeded: function (newValue) {
        const isCancellingSucceeded = newValue
        if (isCancellingSucceeded) {
          this.$Message.success('キャンセルしました')
        } else {
          this.$Message.error('キャンセルに失敗しました')
        }
      }
    },
    data () {
      return {
        receiverMailAddress: '',
        receiverTwitterAccount: ''
      }
    },
    mounted: function () {
      store.dispatch('getGift', { uuid: this.$route.query.giftUuid || '' })
    },
    methods: {
      sendMail () {
        this.$Loading.start()
        store.dispatch('sendMail', { gift: this.sendingGift, mailAddress: this.receiverMailAddress })
      },
      cancelGift () {
        this.$Loading.start()
        store.dispatch('cancelGift', { gift: this.sendingGift })
      }
    }
  }
</script>

<style lang="scss">
    h1, h2 {
        font-weight: normal;
        margin: 16px 0;
    }

    p {
        line-height: 32px;
    }

    .gift_sent_root {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .gift_sent_description {
        margin-bottom: 16px;

        svg {
            width: 84px;
        }
    }

    .send_by_container {
        margin-bottom: 64px;
    }

    .send_email, .share_receiver_account {
        margin-bottom: 72px;
    }

    .cancel_gift_container {
    }

    .cancel_gift {
        margin-bottom: 16px;
    }

    .share_link {
        color: #9B9B9B;
    }
</style>



// WEBPACK FOOTER //
// src/components/GiftSent.vue